export default "__VITE_ASSET__dQr_4qHb__"